import {useState,  useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const columns = [
  { id: 'anio', label: 'Año', width: 150, align: 'center' },
  { id: 'inicioPlaneacionPresupuestal', label: 'Inicio de la planeación presupuestal', width: 150, align: 'center' },
  { id: 'inicioGestionPresupuestal', label: 'Inicio de la gestión presupuestal', width: 150, align: 'center' },
  { id: 'activarMontosPrioridad2', label: 'Fecha para uso de presupuesto prioridad 2', width: 150, align: 'center' },
  { id: 'cierreAdquisiciones', label: 'Cierre de adquisiciones', width: 150, align: 'center' },
  { id: 'cierreTransferencias', label: 'Cierre de transferencias', width: 150, align: 'center' },
  { id: 'cierreGestionPresupuestal', label: 'Cierre de la gestión presupuestal', width: 150, align: 'center' },
  { id: 'limitePartida5000', label: 'Límite para partida 5000', width: 150, align: 'center' },
];

export default function FechasListado(props) {
  const { idEntidad, guardado, setGuardado } = props
  const [configuraciones, setConfiguraciones] = useState([])
  const cargarConfiguraciones = async () => {
  const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionFechas/lista/${idEntidad}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    }

  )
    const data = await res.json()
   // console.log(`FECHAS EN FechasLista ${JSON.stringify(data)}`)
    setConfiguraciones(data)
    setGuardado(false)
  }
  useEffect(() => {
    cargarConfiguraciones()
  }, [guardado])
  return (
    <Paper sx={{ width: '100%', marginTop: 5 }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow key='encabezado'>
              <TableCell key='ninguna' align="center" colSpan={8}>
                Fechas de gestión de presupuesto
              </TableCell>
            </TableRow>
            <TableRow key='encabezado2'>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ top: 57, minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>            
            {configuraciones?configuraciones
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.idConfiguracionFechas}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      const fecha =column.id==='anio'?value:(new Date(value))
                      if(column.id!=='anio')
                        fecha.setDate(fecha.getDate()+1);
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.id==='anio'?value:fecha.toLocaleString('es-MX',{day: "2-digit", month:"short", year:"numeric"})}
                        </TableCell>
                      );
                      })}
                  </TableRow>
                );
              }):<TableRow hover role="checkbox" tabIndex={-1} >
             
                  <TableCell align='center'>
                    No hay fechas registradas
                  </TableCell>
                
            </TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}